const SvgRegisterSettings = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 200 200" {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 200 200"
        >
            <path
                fill="none"
                stroke="#B3DFD8"
                stroke-miterlimit="10"
                stroke-width="10"
                d="M170 75h-29m-41 0H30m0 50h30m40 0h70"
            />
            <path
                fill="none"
                stroke="#B3DFD8"
                stroke-miterlimit="10"
                stroke-width="10"
                d="M135.06 89.57a15 15 0 1 0-10 0M65 110.43a15 15 0 1 0 10 0"
            />
        </svg>
        <circle
            cx="100.5"
            cy="100.5"
            r="100"
            fill="none"
            stroke="#b5e3d8"
            strokeMiterlimit="10"
        />
    </svg>
);

export default SvgRegisterSettings;
